import React from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import Container from "react-bootstrap/Container";
import "./privacy.css";
const Privacy = () => {
  return (
    <>
      <Navb />

      <div className="privacyPolicy">
        <Container>
          <div className="whiteHeading">Privacy Policy</div>
          <div className="whiteP">
            Our privacy policy document is designed for use in relation to this
            website (website) which may collect and process personal
            information. Please read the notes accompanying the privacy policy
            very carefully. Nandi may keep on updating this policy from time to
            time. This policy is effective from start of 01 May, 2020 to the
            date. Nandi is committed to ensuring that your privacy is protected.
            Should we ask you to provide certain information by which you can be
            identified when using this website, then you can be assured that it
            will only be used in accordance with this privacy statement.
          </div>
        </Container>
      </div>
      <div className="privacyCollect">
        <Container>
          <div className="blackHeading" style={{ color: "black" }}>
            What We Collect
          </div>
          <div className="blackP" style={{ color: "black"}}>
            We may collect the following information:
           
              <p>Name and job title</p>
              <p>
                Contact information including email address and phone number
              </p>
              <p>
                Demographic information such as postcode, preferences and
                interests
              </p>
              <p>
                Other information relevant to visitors/customer surveys and/or
                offers
              </p>
          </div>
        </Container>
      </div>
      <div className="privacyGather">
        <Container>
          <div className="whiteHeading">Use of information we gather</div>
          <div className="whiteP" style={{ color: "white" }}>
            We may require this information to understand your needs and provide
            you with better products and services, and in particular for the
            following reasons:
            
              <p>Internal record keeping.</p>
              <p>
                We may use the information to improve our products and services.
              </p>
              <p>
                We may periodically send promotional emails about new products,
                special offers or other information.
              </p>
              <p>
                From time to time, we may also use your information to contact
                you for market research purposes. We may use the information to
                customize the website.
              </p>
            
          </div>
        </Container>
      </div>
      <div className="Security">
        <Container>
          <div className="blackHeading">Security</div>
          <div className="blackP">
            We are committed to ensuring that your information is secure. In
            order to prevent unauthorized access or disclosure, we have put in
            place suitable physical, electronic and managerial procedures to
            safeguard and secure the information we collect online. We will not
            sell, distribute or lease your personal information to third parties
            unless we have your permission or are required by law to do so. We
            may use your personal information to send you promotional
            information about third parties, which we think you may find
            interesting if you tell us that you wish this to happen. Nandi
            undertakes not to disclose the information provided by the visitor
            to this website to any person unless such action is necessary to the
            extent required by law and for regulatory purposes.However, Nandi
            collects non-personally-identifying information of the sort that web
            browsers and servers typically make available, such as the browser
            type, language preference, referring site, and the date and time of
            each visitor request. Nandi's purpose in collecting non-personally
            identifying information is to better understand how the visitors use
            its website. Nandi may, from time to time, release
            non-personally-identifying information in the aggregate, e.g., by
            publishing a report on trends in the usage of its website.If you
            believe that any information we are holding on you is incorrect or
            incomplete, please write to or email us as soon as possible, at our
            address. We will promptly correct any information found to be
            incorrect.
          </div>
        </Container>
      </div>
      <Footer />
    </>
  );
};

export default Privacy;
